/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ClientSurveyResponseModel } from '../../models/client-survey-response-model';
import { CreateSurveyResponseRequest } from '../../models/create-survey-response-request';

export interface CreateSurveyResponse$Plain$Params {
  
    /**
     * properties of new surveyresponse
     */
    body?: CreateSurveyResponseRequest
}

export function createSurveyResponse$Plain(http: HttpClient, rootUrl: string, params?: CreateSurveyResponse$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<ClientSurveyResponseModel>> {
  const rb = new RequestBuilder(rootUrl, createSurveyResponse$Plain.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ClientSurveyResponseModel>;
    })
  );
}

createSurveyResponse$Plain.PATH = '/api/SurveyResponse';
